module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/2/4-c645b8aa1a092aaa049dcbddacb2f05d.jpg";